var React = require("react");
import actions from "../../actions/RegistrationActions";
import store from "../../stores/forms/RegistrationStore";
import AuthoritiesSelect from "./SelectAuthority";
import EmailInput from "./EmailInput";
import InputText from "./InputText";
import LoadingPanel from "../LoadingPanel";

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = store.getState();
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    store.listen(this.onChange);
    actions.fetchAuthorities();
  }

  componentWillUnmount() {
    store.unlisten(this.onChange);
  }

  onChange(state) {
    this.setState(state);
  }
  updateAuthority(value) {
    actions.updateAuthority(value);
  }

  updateEmail(value) {
    actions.updateEmail(value);
  }
  updatePassword(value) {
    actions.updatePassword(value);
  }
  updateFirstname(value) {
    actions.updateFirstname(value);
  }
  updateLastname(value) {
    actions.updateLastname(value);
  }
  updateTerms(event) {
    actions.updateTerms(event.target.value);
  }

  submitForm(event) {
    event.preventDefault();
    actions.submitForm();
  }

  render() {
    if (this.state.success) {
      return (
        <div className="col-sm-12 col-sm-offset-3">
          <p>Please check your emails to confirm your registration.</p>
        </div>
      );
    } else {
      /*
            Regular Expression for Names (firstname, lastname)
            ^[a-zA-ZÀ-ÿ]{1}(?!.*([\s\’\'-])\1)[a-zA-ZÀ-ÿ\s\’\'-]{0,50}[a-zA-ZÀ-ÿ]{1}$


            Regular Expression for emails
            ^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$

            */

      var emailRegExp =
        '^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
      var errorMessage = "";
      if (this.state.errorMessage) {
        errorMessage = (
          <div className="row">
            <div className="col-sm-12 alert alert-danger">
              {this.state.errorMessage}
            </div>
          </div>
        );
      }

      let authoritySelect = null;

      if (this.state.authority == "") {
        authoritySelect = (
          <div className="o-block-p">
            <div className="row">
              <div className="col-sm-12">
                <p className="inputDescription">
                  Pick the authority from the list
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <AuthoritiesSelect handleChange={this.updateAuthority} />
              </div>
            </div>
          </div>
        );
      }

      return (
        <form onSubmit={this.submitForm}>
          {errorMessage}
          {authoritySelect}
          <div className="o-block-p">
            <div className="row">
              <div className="col-sm-12">
                <InputText
                  class="o-input"
                  name="first_name"
                  handleChange={this.updateFirstname}
                  placeholder="Firstname"
                  required={true}
                  message="is required"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <InputText
                  class="o-input"
                  name="last_name"
                  handleChange={this.updateLastname}
                  placeholder="Lastname"
                  required={true}
                  message="is required"
                />
              </div>
            </div>
          </div>
          <div className="o-block-p">
            <div className="row">
              <div className="col-sm-12 o-block-p">
                <p className="inputDescription">
                  Your Email address will be your identifier for logging in.{" "}
                  <br />
                  We will also contact you to verify your account and
                  occasionally for important communications.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <InputText
                  class="o-input"
                  name="email"
                  handleChange={this.updateEmail}
                  placeholder="Email address"
                  regex={emailRegExp}
                  message="Invalid email"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <InputText
                  class="o-input"
                  name="password"
                  handleChange={this.updatePassword}
                  placeholder="Password"
                  regex=".{8,}$"
                  message="must be at least 8 characters"
                  type="password"
                />
              </div>
            </div>
          </div>
          <div className="row o-block-p">
            <div className="col-sm-12 inputForm">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                onChange={this.updateTerms}
              />
              <label htmlFor="terms">
                &nbsp;I agree to the{" "}
                <a href="/conditions" target="_blank" className="o-link tiny">
                  terms and conditions.
                </a>
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 text-center inputSubmit">
              <input
                type="submit"
                className="btn btn-default"
                value="Request Account"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">{this.state.message}</div>
          </div>
          <LoadingPanel noMenu={true} show={this.state.loading} />
        </form>
      );
    }
  }
}

RegistrationForm.propTypes = {
  updateAuthority: React.PropTypes.func,
};

export default RegistrationForm;
